// @flow
import * as React from 'react';
type MilliSecond = number;

export default class AutoHide extends React.PureComponent<
  {
    delay: MilliSecond,
    children: any,
  },
  { show: boolean }
> {
  timeout: ?TimeoutID = null;
  state = {
    show: true,
  };

  static defaultProps = {
    delay: 1000,
  };

  componentDidMount() {
    this.timeout = setTimeout(
      () => this.setState({ show: false }),
      this.props.delay
    );
  }

  componentWillUnmount() {
    this.timeout && clearTimeout(this.timeout);
  }

  render() {
    return this.state.show ? <div>{this.props.children}</div> : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/AutoHide.js